/**
 * Gera um slug de ancora a partir do texto do titulo (sem acento, minusculo,
 * hifenizado). Vivia em src/components/ArtigoToc.tsx, mas esse arquivo e
 * "use client" - Next trata qualquer funcao exportada de um modulo client
 * como uma referencia so-de-cliente, entao um Server Component que tentasse
 * chamar slugify() direto de la quebrava em runtime ("Attempted to call
 * slugify() from the server but slugify is on the client"), mesmo sendo uma
 * funcao pura de string sem nenhuma dependencia de navegador. Extraida aqui
 * (modulo sem "use client") para ser chamavel tanto do servidor
 * (src/lib/articleContent.ts, ao processar o HTML do artigo antes de
 * mandar a resposta) quanto do cliente (ArtigoToc.tsx re-exporta esta
 * mesma funcao, e CaseConteudo.tsx importa daqui tambem).
 */
export function slugify(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
